import { actionTypes } from "..";

export const saveOrderInvoicesValue = (payload) => ({
  type: actionTypes.SAVE_ORDER_INVOICES_VALUE,
  payload,
});

export const getCustomersData = (payload) => ({
  type: actionTypes.GET_CUSTOMERS_DATA,
  payload,
});

export const getDownloadCustomersData = (payload) => ({
  type: actionTypes.GET_DOWNLOAD_CUSTOMERS_DATA,
  payload,
});

export const getCustomersFormData = (payload) => ({
  type: actionTypes.GET_CUSTOMERS_FORM_OPTIONS,
  payload,
});

export const getCustomersFormContactStates = (payload) => ({
  type: actionTypes.GET_CUSTOMERS_FORM_CONTACT_STATES,
  payload,
});

export const getCustomersFormBillingStates = (payload) => ({
  type: actionTypes.GET_CUSTOMERS_FORM_BILLING_STATES,
  payload,
});

export const postCustomersData = (payload) => ({
  type: actionTypes.POST_CUSTOMERS_DATA,
  payload,
});

export const postCustomerFile = (payload) => ({
  type: actionTypes.POST_CUSTOMER_FILE,
  payload,
});
export const getCustomerEditData = (payload) => ({
  type: actionTypes.GET_CUSTOMER_EDIT_DATA,
  payload,
});

export const postCustomerEditData = (payload) => ({
  type: actionTypes.POST_CUSTOMER_EDIT_DATA,
  payload,
});

export const getPayeeList = (payload) => ({
  type: actionTypes.GET_PAYEE_LIST,
  payload,
});

export const getDownloadPayeesList = (payload) => ({
  type: actionTypes.GET_DOWNLOAD_PAYEE_LIST,
  payload,
});

export const postUploadPayeesList = (payload) => ({
  type: actionTypes.POST_UPLOAD_PAYEE_LIST,
  payload,
});

export const getAddPayeeData = (payload) => ({
  type: actionTypes.GET_ADD_PAYEE_DATA,
  payload,
});

export const postAddPayeeData = (payload) => ({
  type: actionTypes.POST_ADD_PAYEE_DATA,
  payload,
});

export const getPayeeLinkedEmployee = (payload) => ({
  type: actionTypes.GET_PAYEE_LINKED_EMPLOYEE,
  payload,
});

export const getPayeeExpenseAccount = (payload) => ({
  type: actionTypes.GET_PAYEE_EXPENSE_ACCOUNT,
  payload,
});

export const getPayeeContactStates = (payload) => ({
  type: actionTypes.GET_PAYEE_CONTACT_STATES,
  payload,
});

export const getPayeeBillingStates = (payload) => ({
  type: actionTypes.GET_PAYEE_BILLING_STATES,
  payload,
});

export const getPayeeEditData = (payload) => ({
  type: actionTypes.GET_EDIT_PAYEE_DATA,
  payload,
});

export const postPayeeEditData = (payload) => ({
  type: actionTypes.POST_EDIT_PAYEE_DATA,
  payload,
});

export const getPayeePaymentInfoOptions = (payload) => ({
  type: actionTypes.GET_PAYEE_PAYMENT_INFO_OPTIONS,
  payload,
});

export const getPayeePaymentInfoData = (payload) => ({
  type: actionTypes.GET_PAYEE_PAYMENT_INFO_DATA,
  payload,
});

export const postPayeePaymentInfoData = (payload) => ({
  type: actionTypes.POST_PAYEE_PAYMENT_INFO_DATA,
  payload,
});

export const postDeletePayeePaymentInfoData = (payload) => ({
  type: actionTypes.POST_DELETE_PAYEE_PAYMENT_INFO_DATA,
  payload,
});

export const getPayeeDocumentData = (payload) => ({
  type: actionTypes.GET_PAYEE_DOCUMENT_DATA,
  payload,
});

export const postPayeeDocumentData = (payload) => ({
  type: actionTypes.POST_PAYEE_DOCUMENT_DATA,
  payload,
});

export const deletePayeeDocumentData = (payload) => ({
  type: actionTypes.DELETE_PAYEE_DOCUMENT_DATA,
  payload,
});

export const getPayeeBankingInfoData = (payload) => ({
  type: actionTypes.GET_PAYEE_BANKING_INFO_DATA,
  payload,
});

export const postPayeeBankingInfoData = (payload) => ({
  type: actionTypes.POST_PAYEE_BANKING_INFO_DATA,
  payload,
});

export const deletePayeeBankingInfoData = (payload) => ({
  type: actionTypes.DELETE_PAYEE_BANKING_INFO_DATA,
  payload,
});

export const postPayeeStatus = (payload) => ({
  type: actionTypes.POST_PAYEE_STATUS,
  payload,
});

export const addPayeePendingApprovalData = (payload) => ({
  type: actionTypes.ADD_PAYEE_PENDING_APPROVAL_DATA,
  payload,
});

// ar invoices
export const postArInvoicesData = (payload) => ({
  type: actionTypes?.POST_AR_INVOICES_DATA,
  payload,
});
export const getNewArInvoicesOptions = (payload) => ({
  type: actionTypes?.GET_NEW_AR_INVOICES_OPTIONS,
  payload,
});

export const getArInvoicesData = (payload) => ({
  type: actionTypes?.GET_AR_INVOICES_DATA,
  payload,
});

export const getOutstandingArInvoicesData = (payload) => ({
  type: actionTypes?.GET_OUTSTANDING_AR_INVOICES_DATA,
  payload,
});

export const getPaidArInvoicesData = (payload) => ({
  type: actionTypes?.GET_PAID_AR_INVOICES_DATA,
  payload,
});

export const getCancelledArInvoicesData = (payload) => ({
  type: actionTypes?.GET_CANCELLED_AR_INVOICES_DATA,
  payload,
});

export const getEditArInvoicesData = (payload) => ({
  type: actionTypes?.GET_EDIT_AR_INVOICES_DATA,
  payload,
});

export const postEditArInvoicesData = (payload) => ({
  type: actionTypes?.POST_EDIT_AR_INVOICES_DATA,
  payload,
});

export const postCancelArInvoice = (payload) => ({
  type: actionTypes?.POST_CANCEL_AR_INVOICE,
  payload,
});

export const getReceivablesList = (payload) => ({
  type: actionTypes?.GET_RECEIVABLES_LIST,
  payload,
});

export const getReceivableDetails = (payload) => ({
  type: actionTypes?.GET_RECEIVABLE_DETAILS,
  payload,
});

export const postReceivePayments = (payload) => ({
  type: actionTypes?.POST_RECEIVE_PAYMENTS,
  payload,
});

export const getCreditNoteList = (payload) => ({
  type: actionTypes?.GET_CREDIT_NOTE_LIST,
  payload,
});
